import type { Fixture, FixtureResources } from "~types/fixture.ts";
import { CompetitorTypes } from "~enums/competitorTypes.ts";
import { getFixtureCompetitorsNames } from "~utilities/getFixtureCompetitorsNames.ts";
import { getFixtureParticipantsNames } from "~utilities/getFixtureParticipantsNames.ts";

const getName = (
  homeEntrant: string | undefined,
  awayEntrant: string | undefined,
  fixtureName: string | undefined,
  notSpecified: string,
) => {
  if (homeEntrant && awayEntrant) {
    return `${homeEntrant || notSpecified} vs ${awayEntrant || notSpecified}`;
  }

  if (homeEntrant || awayEntrant) {
    return `${homeEntrant || notSpecified} vs ${awayEntrant || notSpecified}`;
  }

  return `${fixtureName}`;
};

export const buildFixtureName = (fixture: Fixture, resources: FixtureResources | undefined, notSpecifiedString:string) => {
  if (fixture.competitorType === CompetitorTypes.Entity) {
    const homeCompetitorName = getFixtureCompetitorsNames(true, fixture.competitors, resources);
    const awayCompetitorName = getFixtureCompetitorsNames(false, fixture.competitors, resources);
    return getName(
      homeCompetitorName,
      awayCompetitorName,
      `${fixture.nameLocal || fixture.fixtureId}`,
      notSpecifiedString,
    );
  }

  if (fixture.competitorType === CompetitorTypes.Person) {
    const homeParticipantsNames = getFixtureParticipantsNames(true, notSpecifiedString, fixture.participants, resources);
    const awayParticipantsNames = getFixtureParticipantsNames(false, notSpecifiedString, fixture.participants, resources);
    return getName(
      homeParticipantsNames,
      awayParticipantsNames,
      `${fixture.nameLocal || fixture.fixtureId}`,
      notSpecifiedString,
    );
  }

  return fixture.fixtureId;
}
